<template>
  <div class="shopinfo-box">
    <a-card :bordered="false">
      <div class="shopinfo-content">
        <a-table
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: haoSelect
          }"
          @change="change"
          :columns="columns"
          :dataSource="articleList"
          :pagination="pagination"
          :rowKey="articleList => articleList.article_id"
        >
          <div slot="action" slot-scope="record" class="opera-btn-box">
            <a-button
              type="primary"
              size="small"
              href="javascript:;"
              @click="editArticle(record)"
            >
              <a-icon type="edit" />
            </a-button>
            <a-popconfirm
              :title="'你确定要删除：' + record.article_title + ' 吗?'"
              okText="删除"
              cancelText="取消"
              @confirm="deleteArticle(record)"
            >
              <a-button type="primary" size="small" href="javascript:;">
                <a-icon type="delete" />
              </a-button>
            </a-popconfirm>
          </div>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import { SETTING_query, SETTING_update } from "@/api/setting";
import { Article_list, Article_delete } from "@/api/article";
import "@/utils/directive";
const columns = [
  {
    title: "id",
    dataIndex: "article_id"
  },
  {
    title: "标题",
    dataIndex: "article_title"
  },
  {
    title: "状态",
    dataIndex: "article_status"
  },
  {
    title: "排序",
    dataIndex: "article_sort"
  },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
export default {
  data() {
    return {
      siteInfo: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      columns,
      form: {
        desc: ""
      },
      articleList: [],
      selectedRowKeys: [],
      pagination: {
        total: 0,
        pageSize: 10,
        showTotal: total => `总数: ${total} 条`
      }
    };
  },
  created() {},
  mounted() {
    this.getInfo({ type: "haodesc" });
    this.getList({ limit: this.pagination.pageSize, skip: 0 });
  },
  methods: {
    getInfo: function(_obj) {
      SETTING_query(_obj)
        .then(response => {
          this.form = response.res;
        })
        .catch(() => {});
    },
    getList: function(_obj) {
      Article_list(_obj)
        .then(response => {
          this.articleList = response.res.data;
          this.pagination.total = response.res.total;
        })
        .catch(() => {});
    },
    setInfo: function(_obj) {
      SETTING_update({
        type: "haodesc",
        info: _obj
      })
        .then(response => {
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          } else {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    },
    haoSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    change: function(_data) {
      //翻页
      let _skip = (_data.current - 1) * _data.pageSize;
      this.getList({ limit: this.pagination.pageSize, skip: _skip });
    },
    editArticle: function(_data) {
      // 修改文章
      console.log(_data);
      this.$router.push({
        name: "articlecreated",
        params: { id: _data.article_id }
      });
    },
    deleteArticle: function(_data) {
      // 删除文章
      console.log(_data);
      Article_delete({
        id: _data.article_id
      })
        .then(response => {
          if (response.status === 0) {
            this.$notification.success({
              message: "提示",
              description: response.res
            });
            this.getList({
              limit: this.pagination.pageSize,
              skip: 0
            });
          } else {
            this.$notification.error({
              message: "提示",
              description: response.res
            });
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.shopinfo-content {
  .opera-btn-box {
    .ant-btn:first-child {
      margin-right: 10px;
    }
  }
  .btn-list {
    margin-top: 30px;
  }
  form textarea.ant-input {
    min-height: 500px;
  }
}
</style>
